import { Controller } from "@hotwired/stimulus"

// Opens an Edit Nav dialog: the sections one by default, the apps one with event: "apps".
export default class extends Controller {
    static values = { event: { type: String, default: "edit" } }

    open() { window.dispatchEvent(new Event(`navigation:${this.eventValue}`)) }
}
